export const CLEAR_FORM = 'CLEAR_FORM';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const SET_ACTIVE_EVENT = 'SET_ACTIVE_EVENT';
export const SET_ACTIVE_MOMENT = 'SET_ACTIVE_MOMENT';
export const SET_EVENTS_LOADED = 'SET_EVENTS_LOADED';
export const SET_CHANNEL_ACTIVE = 'SET_CHANNEL_ACTIVE';
export const SET_CHANNEL_EDITING = 'SET_CHANNEL_EDITING';
export const SET_ACTIVE_DISCOVER = 'SET_ACTIVE_DISCOVER';
export const SET_SIDEBAR_CLICKED = 'SET_SIDEBAR_CLICKED';
export const CLEAR_ACTIVE_CHANNEL = 'CLEAR_ACTIVE_CHANNEL';
export const SET_EXPANDED_DISCOVER = 'SET_EXPANDED_DISCOVER';
export const SET_ACTIVE_NOTIFICATION = 'SET_ACTIVE_NOTIFICATION';
